import { Form as AntdForm, Card } from 'antd'
import { DateStyles } from 'components/DatePickerStyled/Styles/Styles.js'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import styled from 'styled-components'
import { COLORS } from 'theme'

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    &::-webkit-scrollbar {
      display: none;
    }
  }
`
export const SectionWrapper = styled.div``
export const StyledCard = styled(Card)`
  padding: 1rem;
  border-radius: 10px;
  box-shadow: 0 6px 6px rgba(0, 0, 0, 0.2);
  .ant-card-head {
    padding: 0;
  }
  .ant-card-body {
    padding: 1rem 0;
  }
`
export const ItemsFlex = styled(Flex)`
  padding: 0.3rem 0.8rem;
  align-items: center;
`
export const LightText = styled(Flex)`
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.25rem;
  color: ${COLORS.PRIMARY_GREY_T_50};
  gap: 10px;
  flex: 1 1 0;
  align-items: center;
`
export const BoldText = styled.div`
  font-size: 0.975rem;
  font-weight: 700;
  line-height: 1.25rem;
  color: ${COLORS.PRIMARY_GREY_T_30};
  flex: 1 1 0;
  margin-left: 2rem;
`
export const ModeText = styled(BoldText)`
  text-transform: capitalize;
`
export const LocationText = styled.div`
  max-width: 60%;
  font-size: 0.975rem;
  font-weight: 400;
  line-height: 1.5rem;
  color: ${COLORS.PRIMARY_GREY_T_50};
  margin-left: 2rem;
`
export const HighlitedCount = styled.span`
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25rem;
`
export const CountInfoContainer = styled(Flex)`
  background-color: ${COLORS.PURPLE_T_95};
  padding: 10px;
  gap: 10px;
  align-items: flex-start;
  border-radius: 10px;
  margin: 1rem 0;
`
export const CountInfo = styled.div`
  font-weight: 600;
  font-size: 13px;
  line-height: 1.25rem;
`
export const FooterFlex = styled(Flex)`
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
`

export const FormItem = styled(AntdForm.Item)`
  margin-bottom: 0px !important;
`
export const Form = styled(AntdForm)`
  row-gap: 20px;
  display: flex;
  flex-direction: column;
`
export const TwoFields = styled(Flex)`
  gap: 20px;
`
export const DivWrapper = styled.div`
  width: 100%;
`
export const DatePaper = styled(DateStyles)`
  margin-top: 5px;
  width: 100%;
`
export const StyledInput = styled(Input)`
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
`
